<template>
	<v-card
		outlined
		class="mb-4"
		:class="{ 'grey lighten-2': dragover }"
		@drop.prevent="onDrop($event)"
		@dragover.prevent="dragover = true"
		@dragenter.prevent="dragover = true"
		@dragleave.prevent="dragover = false">
		<v-card-text>
			<input
				ref="uploader"
				class="d-none"
				type="file"
				multiple
				@change="onSelect($event)" />
			<v-row class="d-flex flex-column"
				dense
				align="center"
				justify="center"
				@click="$refs.uploader.click()">
				<v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
					mdi-cloud-upload
				</v-icon>
				<p>
					Drop your file(s) here, or click to select them.
				</p>
			</v-row>
			<v-list v-if="uploadedFiles.length > 0" color="grey lighten-4">
				<v-virtual-scroll
					:items="uploadedFiles"
					min-height="62"
					max-height="500"
					item-height="50">
					<template #default="{ item }">
						<v-list-item :key="item.name">
							<v-list-item-content>
								<v-list-item-title>
									{{ item.name }}
									<span class="ml-3 text--secondary">
										{{ item.size | prettyBytes }} bytes</span>
								</v-list-item-title>
							</v-list-item-content>

							<v-list-item-action>
								<v-btn icon @click.stop="removeFile(item.name)">
									<v-icon>mdi-close-circle</v-icon>
								</v-btn>
							</v-list-item-action>
						</v-list-item>
					</template>
				</v-virtual-scroll>
			</v-list>
		</v-card-text>

		<v-divider />

		<v-card-actions>
			<v-spacer></v-spacer>

			<v-btn v-if="length(uploadedFiles)"
				elevation="0"
				color="red lighten-2"
				dark
				@click="uploadedFiles = []">
				Cancel
			</v-btn>

			<v-btn color="success"
				elevation="0"
				:disabled="! length(uploadedFiles)"
				:loading="loading"
				@click.stop="submit">
				<span v-if="! length(uploadedFiles)" class="ml-2">Upload</span>
				<span v-else class="ml-2">Upload ({{ length(uploadedFiles) }}) Files </span>
				<v-icon right>mdi-upload</v-icon>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	name: 'Uploader',
	props: {
		value: {
			type: Boolean,
			default: null
		}
	},
	data () {
		return {
			dragover: false,
			uploadedFiles: []
		}
	},
	computed: {
		loading () {
			return this.value === true
		}
	},
	watch: {
		value (status) {
			if (status === false) {
				this.uploadedFiles = []
			}
		}
	},
	methods: {
		removeFile (fileName) {
			const index = this.uploadedFiles.findIndex(
				file => file.name === fileName
			)

			if (index > -1) {
				this.uploadedFiles.splice(index, 1)
			}
		},
		onDrop (e) {
			if (! e.dataTransfer) {
				this.dragover = false
				return
			}

			for (const filesKey in e.dataTransfer.files) {
				if (!e.dataTransfer.files.hasOwnProperty(filesKey)) continue
				this.uploadedFiles.push(e.dataTransfer.files[filesKey])
			}

			this.dragover = false
		},
		onSelect (e) {
			for (const filesKey in e.target.files) {
				if (!e.target.files.hasOwnProperty(filesKey)) continue
				this.uploadedFiles.push(e.target.files[filesKey])
			}

			this.dragover = false
			document.activeElement.blur()
		},
		submit () {
			this.$emit('uploaded', this.uploadedFiles)
		}
	}
}
</script>
